import type { App } from 'vue';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';

import AppComponent from '@/App.vue';
import createErrorHandler from '@modules/core/errors/createErrorHandler';
import { getEnvConfig } from '@modules/core/services/env-config/utils/envConfig';

import getApp from './getApp';
import registerPlugins from './registerPlugins';

export default async function createApp(): Promise<App> {
  await getEnvConfig();

  const app = getApp(AppComponent);
  await registerPlugins(app);

  app.use(ToastService);
  app.use(ConfirmationService);
  createErrorHandler(app);

  return app;
}
